import {Message} from 'element-ui';
/**
 * 音频数据映射
 * @param {Object} data 上传后的音频数据
 * @returns
 */
export function audioKeyMap(data) {
    const {url, size, format, khz, kbs, duration, bits, fileName, channel, quality} = data || {};
    return {
        path: url,
        size,
        format,
        khz,
        kbps: kbs,
        duration,
        bits,
        fileName: fileName.substring(0, fileName.lastIndexOf('.')),
        channel,
        quality,
        name: fileName.substring(0, fileName.lastIndexOf('.')),
    };
}

/**
 * 音频验证
 * @param {Object} file 文件对象
 * @param {Object} limit 验证文件对象
 */
export function audioBeforeUploadHandle(file, limit) {
    return new Promise((resolve, reject) => {
        const {maxSize, accept} = limit;
        //格式检查
        let _accept = accept.split(',') || [];
        _accept = _accept.map((item) => item.trim());
        
        const fileName = file.name || '';
        const fileExt = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
        // const acceptedExts = ['wav', 'mp3', 'flac', 'm4a', 'aif', 'aiff'];
        const acceptedExts = ['wav'];
        
        const isFormat = _accept.some((v) => {
            if (v === file.type) return true;
            const extFromMime = v.split('/')[1];
            if (extFromMime === 'x-wav' && fileExt === 'wav') return true;
            if (extFromMime && fileExt === extFromMime) return true;
            return false;
        }) || (fileExt && acceptedExts.includes(fileExt));
        
        if (!isFormat) {
            Message.error('只能上传WAV音频,请重新上传');
            return reject();
        }

        //大小检查
        const isSize = file.size / 1024 / 1024 <= maxSize ? true : false;
        if (!isSize) {
            Message.error(`文件不能大于${maxSize}M,请重新上传`);
            return reject();
        }
        resolve();
    });
}
